export default __webpack_public_path__ + "static/media/cookie.eaf54804.svg";